<template>
	<!-- SCHEDULE FORM -->
	<base-modal :show="showLeagueScheduleForm" @close="close">
		<league-schedule-form :division="selectedDivision" @close-schedule-modal="close"></league-schedule-form>
		<template v-slot:buttons>
			<button class="btn btn-info btn-lg" @click="close">Cancel</button>
		</template>
	</base-modal>
	<!-- ADD TEAM FORM -->
	<base-modal :show="showTeamForm" @close="close">
		<h2 class="text-info mb-5">Add a team</h2>
		<div class="container">
			<form @submit.prevent="submitTeamForm">
				<div class="form-floating">
					<input type="text" class="form-control" id="floatingNewTeam" v-model.trim="addNewTeam" />
					<label for="floatingNewTeam">Team Name</label>
				</div>
				<button :disabled="isLoading" class="btn btn-outline-info btn-lg mt-5">
					<div v-show="isLoading">
						<i class="fa-solid fa-baseball fa-spin"></i>
						Loading...
					</div>
					<div v-show="!isLoading">Add</div>
				</button>
			</form>
		</div>
		<template v-slot:buttons>
			<button class="btn btn-info btn-lg ms-1" @click="close">Cancel</button>
		</template>
	</base-modal>
	<!-- CONFIRM DELETE MODAL -->
	<base-modal :show="showConfirmDelete" title="Delete?" @close="showConfirmDelete = false">
		<template v-slot:buttons>
			<button class="btn btn-outline-danger" @click="confirmedDeleteTeam">Delete</button>
		</template>
	</base-modal>
	<!-- ADD DIVISION FORM -->
	<base-modal :show="addDivision" @close="addDivision = false">
		<form @submit.prevent="submitDivisionForm">
			<div class="form-floating">
				<input type="text" class="form-control" id="floatingNewTeam" v-model.trim="division" />
				<label for="floatingNewTeam">Division Name</label>
			</div>
			<button :disabled="isLoading" class="btn btn-outline-info btn-lg mt-5">
				<div v-show="isLoading">
					<i class="fa-solid fa-baseball fa-spin"></i>
					Loading...
				</div>
				<div v-show="!isLoading">Add</div>
			</button>
		</form>
		<template v-slot:buttons>
			<button class="btn btn-info btn-lg ms-1" @click="addDivision = false">Cancel</button>
		</template>
	</base-modal>
	<!-- SECTION -->
	<h1 class="text-info mt-4">League Manager Dashboard</h1>
	<!--  SELECT DIVISION CARD -->
	<div class="card mt-5 mb-3" style="background-color: #263238">
		<div class="card-body">
			<div class="row">
				<div class="col">
					<div class="form-floating">
						<select class="form-select" id="floatingSelectGrid" v-model="selectedDivision">
							<option value="">Division</option>
							<option v-for="div in getDivisions" :key="div" :value="{ id: div.id }">
								{{ div.division }}
							</option>
						</select>
						<label for="floatingSelectGrid">Select a</label>
					</div>
				</div>
				<div class="col">
					<button class="btn btn-info btn-lg btn-block pt-3 pb-3 mt-1" @click="addDivision = true">
						Add a division
					</button>
				</div>
			</div>
		</div>
	</div>
	<div v-if="selectedDivision !== ''" class="row row-cols-1 row-cols-md-3 g-4">
		<div class="col">
			<!-- LEAGUE PLAYERS AND TEAMS CARD -->
			<div class="card h-100 text-info" style="background-color: #263238">
				<div class="card-body">
					<h5 class="card-title">
						{{ getUsers.length }} League Player{{ getUsers.length === 0 || getUsers.length > 1 ? 's' : '' }}
					</h5>
					<div class="accordion accordion-flush">
						<div class="accordion-item" v-for="team in getAllTeams" :key="team">
							<h6 class="accordion-header pt-2">
								{{ team.team }}
								<button
									class="accordion-button collapsed"
									type="button"
									data-bs-toggle="collapse"
									:data-bs-target="'#' + team.id"
									aria-expanded="false"
									aria-controls="flush-collapseOne"
								>
									{{ getTeamPlayersCount(team.team) }} Player{{
										getTeamPlayersCount(team.team) === 0 || getTeamPlayersCount(team.team) > 1
											? 's'
											: ''
									}}
								</button>
							</h6>
							<div
								:id="team.id"
								class="accordion-collapse collapse"
								aria-labelledby="flush-headingOne"
								data-bs-parent="#accordionFlushExample"
							>
								<div class="accordion-body">
									<ul class="list-group list-group-flush" v-for="user in getUsers" :key="user">
										<li v-if="user.team === team.team" class="list-group-item">
											{{ user.firstName }} {{ user.lastName }} - {{ user.userType }}
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="card-footer">
					<!-- <small class="text-muted">Last updated 3 mins ago</small> -->
				</div>
			</div>
		</div>
		<div class="col">
			<!-- TEAM CARD DELETE TEAM -->
			<div class="card h-100 text-info" style="background-color: #263238">
				<div class="card-body">
					<h5 class="card-title">{{ getAllTeams.length }} Teams</h5>
					<div class="list-group">
						<div
							v-for="team in getAllTeams"
							:key="team"
							href="#"
							class="list-group-item list-group-item-action list-group-item-info"
						>
							{{ team.team }}
							<div class="d-inline float-end">
								<a role="button" @click="confirmDeleteTeam(team.id)"
									><i class="fa-solid fa-xmark"></i
								></a>
							</div>
						</div>
					</div>
				</div>
				<div class="card-footer">
					<div>
						<button @click="showTeamForm = true" class="btn btn-outline-info">Add a team</button>
					</div>
				</div>
			</div>
		</div>
		<div class="col">
			<!-- SCHEDULE CARD -->
			<div class="card h-100 text-info" style="background-color: #263238">
				<div class="card-body">
					<h5 class="card-title">Schedules</h5>
					<div class="list-group">
						<a
							v-for="schedule in getAllSchedules"
							:key="schedule"
							href="#"
							class="list-group-item list-group-item-action list-group-item-info"
							>{{ schedule.season }}</a
						>
					</div>
				</div>
				<div class="card-footer">
					<small class="text-muted">
						<div>
							<button @click="showLeagueScheduleForm = true" class="btn btn-outline-info">
								Create a League Schedule
							</button>
						</div>
					</small>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import LeagueScheduleForm from '@/components/league/LeagueScheduleForm.vue';
export default {
	components: {
		LeagueScheduleForm,
	},
	data() {
		return {
			showLeagueScheduleForm: false,
			showTeamForm: false,
			addNewTeam: '',
			showConfirmDelete: false,
			teamDeleteId: null,
			division: '',
			selectedDivision: '',
			addDivision: false,
		};
	},
	created() {
		this.loadSchedules();
		this.loadUsers();
		this.loadDivisions();
	},
	computed: {
		userLeague() {
			return this.$store.getters.userLeague;
		},
		userLeagueId() {
			return this.$store.getters.userLeagueId;
		},
		getAllSchedules() {
			return this.$store.getters['leagues/allSchedules'];
		},
		getAllTeams() {
			return this.$store.getters['teams/allTeams'];
		},
		getDivisions() {
			return this.$store.getters['leagues/allDivisions'];
		},
		currentDivision() {
			const allDivisions = this.getDivisions;
			return allDivisions.filter((i) => i.id === this.selectedDivision.id);
		},
		getUsers() {
			const users = this.$store.getters.allUsers;
			const filteredUsers = users.filter((i) => i.userType !== 'League Manager');
			const loggedUser = this.$store.getters.userLeagueId;
			return filteredUsers.filter((user) => user.leagueId === loggedUser);
		},
	},
	watch: {
		selectedDivision() {
			this.loadTeams();
			this.loadSchedules();
		},
	},
	methods: {
		getTeamPlayersCount(team) {
			const users = this.getUsers;
			const filterUsers = users.filter((i) => i.team === team);
			return filterUsers.length;
		},
		async submitTeamForm() {
			const payloadNewTeam = {
				team: this.addNewTeam,
				divisionId: this.selectedDivision.id,
			};
			try {
				await this.$store.dispatch('teams/addNewTeamManager', payloadNewTeam);
			} catch (err) {
				this.error = err.message || 'Team add failed... Try again.';
			}
			this.addNewTeam = '';
			this.isLoading = false;
			this.showTeamForm = false;
			this.loadTeams();
		},
		async submitDivisionForm() {
			const payload = {
				division: this.division,
			};
			try {
				await this.$store.dispatch('leagues/addNewDivision', payload);
			} catch (err) {
				this.error = err.message || 'Team add failed... Try again.';
			}
			this.isLoading = false;
			this.addDivision = false;
			this.loadTeams();
		},
		confirmDeleteTeam(id) {
			this.showConfirmDelete = true;
			this.teamDeleteId = id;
		},
		confirmedDeleteTeam() {
			this.deleteThisTeam(this.teamDeleteId);
			this.showConfirmDelete = false;
		},
		deleteThisTeam(id) {
			const payload = {
				id: id,
				divisionId: this.selectedDivision.id,
			};
			this.$store.dispatch('teams/deleteTeam', payload);
			setTimeout(() => {
				this.loadTeams();
			}, 500);
		},
		async loadSchedules() {
			const payload = {
				divisionId: this.selectedDivision.id,
			};
			try {
				this.isLoading = true;
				await this.$store.dispatch('leagues/fetchSchedules', payload);
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
			this.isLoading = false;
		},
		async loadDivisions() {
			try {
				await this.$store.dispatch('leagues/fetchDivisions');
			} catch (error) {
				this.error = error.message;
			}
		},
		async loadTeams() {
			const payload = {
				divisionId: this.selectedDivision.id,
			};
			try {
				this.isLoading = true;
				await this.$store.dispatch('teams/fetchManagerTeams', payload);
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
			this.isLoading = false;
		},
		async loadUsers() {
			try {
				this.isLoading = true;
				await this.$store.dispatch('fetchUsers');
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
			this.isLoading = false;
		},
		close() {
			this.showLeagueScheduleForm = false;
			this.showTeamForm = false;
		},
	},
};
</script>
